@let data = transactionDetails();
@let theftLabelText = theftLabel();
@let isIncident = isTheftInternal();

@if (data) {
  <app-pan-card
    [isPageContainer]="true"
    [pageContainerSize]="'lg'"
    class="mb-10"
    [header]="data.case ? `Case ${data.case.num}: Instance ${data.case.instance_num}` : ''"
  >
    @if (!isReview() && mode() === "normal") {
      <div leftActions>
        <app-pan-button [mat-dialog-close]="getDialogReturnValue()" aria-label="Close" icon="close"> </app-pan-button>
      </div>
    }

    @if (!isReview() && mode() === "normal") {
      <div rightActions class="flex gap-2">
        <app-pan-button
          [matMenuTriggerFor]="incidentMenu"
          icon="arrow_drop_down"
          color="info"
          [label]="theftLabelText"
          [disabled]="updatingCategory()"
          [state]="updatingCategory() ? 'loading' : 'default'"
        >
          <mat-menu #incidentMenu="matMenu">
            @if (theftLabelText === "No incident" || !isIncident) {
              <button (click)="handleTheftChange(true)" mat-menu-item>Incident</button>
            }
            @if (theftLabelText === "Incident" || !isIncident) {
              <button (click)="handleTheftChange(false)" mat-menu-item>No incident</button>
            }
            <button mat-menu-item>Operational Issue</button>
          </mat-menu>
        </app-pan-button>
      </div>
    }

    <section class="text-center mb-4 flex flex-col gap-2">
      <div>{{ data.cancellation.details.name }} ({{ data.cancellation.details.branch }})</div>

      <div class="text-sm italic">
        {{ data.cancellation.details.cancel_date | date: "MM/dd/yyyy hh:mm:ss a" }}
      </div>

      <app-pan-chip color="info">Cancellation</app-pan-chip>
    </section>

    <app-pan-section-header title="Comments" class="my-2"></app-pan-section-header>

    <app-transaction-comments
      [cancellationId]="cancellationId()"
      [comments]="[]"
      (newComment)="handleNewComment()"
      [mode]="mode()"
    ></app-transaction-comments>

    <app-pan-section-header title="Video(s)" class="my-2"></app-pan-section-header>

    @if (videoClips().length > 0) {
      <div data-testid="transaction_details_video_clips_container" class="flex flex-wrap gap-2">
        @for (video of videoClips(); track $index) {
          <div class="w-full lg:w-[49%]">
            <app-pan-video [src]="video.link" data-testid="transaction-details-video"></app-pan-video>
          </div>
        }
      </div>
    } @else if (sharedVideoLinks().length > 0) {
      <table data-testid="transaction_details_shared_links_container" class="live-streams">
        <tr>
          <th class="font-normal">Shared Video Clip</th>
          @if (hasPasswords()) {
            <th class="font-normal">Password</th>
          }
        </tr>

        @for (v of sharedVideoLinks(); track $index) {
          <tr>
            <td>
              <a class="underline" [href]="v.link" target="_blank">{{ v.link }}</a>
            </td>

            @if (v.password) {
              <td>
                <a (click)="copyToClipboard($event, v.password)">{{ v.password }}</a>
              </td>
            }
          </tr>
        }
      </table>
    }

    @if (hasLiveStreams()) {
      <table class="live-streams">
        <tr>
          <th>Camera name</th>
          <th>Rhombus link</th>
        </tr>
        @for (ls of liveStreams(); track $index) {
          <tr>
            <td>{{ ls.rhombus_camera_name }}</td>
            <td>
              <a class="underline" href="{{ ls.live_stream_link }}" target="_blank">{{ ls.live_stream_link }}</a>
            </td>
          </tr>
        }
      </table>
    }

    @if (data.photos) {
      <app-pan-section-header title="Photo(s)" class="my-2"></app-pan-section-header>

      <div class="flex flex-row flex-wrap items-center gap-2">
        @for (imageUrl of data.photos; track imageUrl) {
          <img [src]="imageUrl" class="max-w-full max-h-[50vh] block" alt="suspect photo" />
        }
      </div>
    }

    <app-pan-section-header title="Details" class="my-2"></app-pan-section-header>

    <app-cancellation-details
      (removeCancellation)="handleRemoveCancellation($event)"
      [cancellationId]="data.image_id"
      [cancellationItems]="data.cancellation.items"
      [mode]="mode()"
    ></app-cancellation-details>

    <app-pan-section-header title="Transactions" class="my-2"></app-pan-section-header>

    @if (timelineRows().length > 0) {
      <app-incident-timeline-table [rows]="timelineRows()"></app-incident-timeline-table>
    }
    @if (isDiscussionsEnabled()) {
      <div class="flex justify-center my-4" panRole [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager']">
        <app-discussion-thread type="incident-report" [id]="cancellationId()"></app-discussion-thread>
      </div>
    }

    @if (data.is_self_service) {
      <app-pan-inline-alert panRole [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager']" type="primary" class="my-2">
        This incident was submitted by system
      </app-pan-inline-alert>
    }
  </app-pan-card>
}
